import { alpha } from "@mui/material/styles";

const createCustomShadow = (theme, color) => {
  const transparent = alpha(color, 0.08); // Reducido de 0.24 a 0.08 para más minimalismo
  const veryLight = alpha(color, 0.04);
  return {
    z1: `0 1px 3px 0 ${veryLight}`, // Sombras muy sutiles
    z8: `0 2px 8px 0 ${transparent}`, // Reducidas significativamente
    z12: `0 4px 12px 0 ${transparent}`, // Más planas
    z16: `0 6px 16px 0 ${transparent}`, // Menos prominentes
    z20: `0 8px 20px 0 ${transparent}`, // Más sutiles
    z24: `0 10px 24px 0 ${transparent}`, // Minimalistas

    // Sombras de colores más sutiles para minimalismo
    primary: `0px 4px 12px 0px ${alpha(theme.palette.primary.main, 0.15)}`, // Reducido de 0.3
    secondary: `0px 4px 12px 0px ${alpha(theme.palette.secondary.main, 0.15)}`,
    orange: `0px 4px 12px 0px ${alpha(theme.palette.orange.main, 0.15)}`,
    success: `0px 4px 12px 0px ${alpha(theme.palette.success.main, 0.15)}`,
    warning: `0px 4px 12px 0px ${alpha(theme.palette.warning.main, 0.15)}`,
    error: `0px 4px 12px 0px ${alpha(theme.palette.error.main, 0.15)}`,
  };
};

export default function customShadows(navType, theme) {
  return navType === "dark" ? createCustomShadow(theme, theme.palette.dark.main) : createCustomShadow(theme, theme.palette.grey[600]);
}
